import {
  ShiftPlanStatus,
  ShiftPlanStatusTranslationMap,
} from '@wilson/interfaces';
import { FilterOptions } from '../../options.interface';

export const ShiftPlanFilterOptions: FilterOptions[] = [
  {
    id: ShiftPlanStatus.Draft,
    name: ShiftPlanStatusTranslationMap[ShiftPlanStatus.Draft],
  },
  {
    id: ShiftPlanStatus.Reverted,
    name: ShiftPlanStatusTranslationMap[ShiftPlanStatus.Reverted],
  },
  {
    id: ShiftPlanStatus.RolledOut,
    name: ShiftPlanStatusTranslationMap[ShiftPlanStatus.RolledOut],
  },
];
